import React from "react";
import styled from "styled-components";

export default styled.h3`
    font-size: 17px;
    color: #5562C0 !important;
    font-weight: 700;
    line-height: 21px;
    text-transform: uppercase;
`;